/**
 * Session Counter Replacer View
 */

define(function(require, exports, module) {
    'use strict';

    var BaseReplacerView = require('common/base.replacer.view');
    var user = require('user');

    module.exports = BaseReplacerView.extend({

        tagName: 'span',

        className: 'fn-session-ticker',

        accessRules: {
            allow: ['user']
        },

        subscribe: function() {
            this.interval = setInterval(this.render.bind(this), 1000);
        },

        destroy: function() {
            clearInterval(this.interval);
        },

        render: function() {
            this.$el.html(this.tmpl('session-ticker', {
                sessionTime: Date.now() - user.get('sessionStartTime')
            }));

            return this;
        }
    }, {
        nameOfReplacers: [
            'SESSION_TICKER'
        ]
    });
});
